module.exports = __webpack_public_path__ + "img/toothy-smile.980b5138.png";